import BASE_URL from '../config/api';
import { getStoredAuthToken } from './auth';

const request = async (callId, suffix, options = {}) => {
  const token = getStoredAuthToken();
  if (!token) throw new Error('Authentication is required');
  const response = await fetch(`${BASE_URL}/api/calls/${encodeURIComponent(callId)}${suffix}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || 'Call transfer request failed');
  return payload;
};

export const getCallTransferTargets = (callId) => request(callId, '/transfer-targets');
export const transferCall = (callId, target) => request(callId, '/transfer', {
  method: 'POST',
  body: JSON.stringify(target),
});
